import AskChartUserTable from './AskChartUserTable.jsx';
import LearnWithAIUserTable from './LearnWithAIUserTable.jsx';
import AhaMomentUserTable from './AhaMomentUserTable.jsx';

export const aiAgents = [
  {
    id: 'ask_the_chart',
    label: 'Ask the Chart',
    firestoreCollection: 'user_aiagent_ask_the_chart_interactions',
    component: AskChartUserTable,
    bg: '#DDF6FF'
  },
  {
    id: 'learn_with_ai',
    label: 'Learn with AI',
    firestoreCollection: 'user_aiagent_learn_with_ai_interactions',
    component: LearnWithAIUserTable,
    bg: '#FFF1E7'
  },

  {
    id: 'aha_moment',
    label: 'Aha moment Concept Clarity - June 29 Friday Newsletter Public Feature',
    firestoreCollection: 'user_learn_aha_moment_ai_interactions',
    component: AhaMomentUserTable,
    bg: '#FFF7F0'
  },


  // ✅ Add more agents here in the future!
];
